import { Vue, Component, Watch } from "vue-property-decorator";
import RTCClient from "./../agora-rtc-client.js";
import StreamPlayer from "../player-view/PlayerView.vue";
import MeetingModal from "../meeting-modal/MeetingModalView.vue";
import moment from "moment";
import { MeetingLayout, meetingLayout } from "@/consts/MeetingLayouts";

@Component({
  components: {
    StreamPlayer,
    MeetingModal
  }
})
export default class MeetingView extends Vue {
  option = {
    appid: "128c846a004540aa9ebe380105f9a460",
    token: null,
    uid: null,
    channel: null,
    role: "host"
  };
  disableJoin = false;
  isDisableVideo = true;
  isDisableAudio = true;
  isDisableScreen = false;
  isShowResidentsRow = false;
  isShowParticipantsOnline = false;
  publishedParticipants = [];
  onlineParticipants = [];
  rtc: any = {};
  userPublished: any = {}
  usersPublished = []
  eventStart = moment(this.calendarEvent.start).toDate()
  eventEnd = moment(this.calendarEvent.end).toDate()
  isChangeLayout = false
  layouts = "auto"
  meetingLayouts: MeetingLayout[] = meetingLayout;
  newParticipants = [];
  oldParticipants = [];

  get calendarEvent() {
    return this.$store.state.calenderModule.currentCalenderEvent;
  }
  get selectedFacility() {
    return this.$store.state.facilityModule.selectedFacility;
  }
  get authUser() {
    return this.$store.state.authModule.user
  }
  get residents() {
    return this.$store.state.residentModule.residentsShortData;
  }
  get additionalServices() {
    return this.$store.state.additionalServicesModule.additionalServices
  }
  get socialClubsDropdown() {
    return this.$store.state.socialClubModule.socialClubsDropdown
  }
  get presenter() {
    return {
      uid: '',
      userId: this.selectedFacility.id ? this.selectedFacility.id : "",
      userName: this.selectedFacility.name ? this.selectedFacility.name : "",
      imageUrl: this.authUser?.profilePicUrl ? this.authUser.profilePicUrl : "",
      isCameraOff: false,
      isAudioOff: false
    };
  }
  get additionalService() {
    let additionalService = this.additionalServices.find(additionalService =>
      this.calendarEvent?.invitees.includes(additionalService.id)
    );
    if (!additionalService) {
      additionalService = this.socialClubsDropdown.find(additionalService =>
        this.calendarEvent?.invitees.includes(additionalService.id)
      );
    }
    return additionalService;
  }
  get availibleAttendance() {
    const membersIds = this.additionalService?.membersIds;
    if (!this.$route.params.availibleAttendance) {
      if (membersIds) {
        // List Members Premium Services
        return this.residents.filter(resident => {
          if (
            membersIds.includes(resident.id) &&
            !this.calendarEvent.attendeesIds?.includes(resident.id)
          ) {
            return resident;
          }
        });
      } else {
        // List Members Lifestyle Services
        return this.residents.filter(
          resident => !this.calendarEvent.attendeesIds?.includes(resident.id)
        );
      }
    } else {
      return this.$route.params.availibleAttendance;
    }
  }
  get residentsInvitees() {
    const res = []
    if (this.availibleAttendance) {
      this.availibleAttendance.forEach(resident => {
        res.push(resident.id);
      });
    }
    return res;
  }
  @Watch('publishedParticipants')
  onpublishedParticipants(val, oldVal) {
    if (!val.length) {
      this.isShowResidentsRow = false;
    } else {
      this.isShowResidentsRow = true;
    }
  }
  @Watch('calendarEvent')
  onCalendarEventChange(newCalendarEvent, oldCalendarEvent) {
    this.newParticipants = newCalendarEvent.participants;
    this.oldParticipants = oldCalendarEvent.participants;
    this.udpdateParticipants();
  }
  @Watch('usersPublished')
  onUsersPublished() {
    this.udpdateParticipants();
  }
  udpdateParticipants() {
    this.newParticipants.forEach(participant => {
      if (
        this.usersPublished.find(user => user.uid === participant.uid)
      ) {
        const userCurrent: any = this.usersPublished.filter(user => user.uid === participant.uid)[0];
        userCurrent.userName = participant.userName;
        userCurrent.userId = participant.userId;
        userCurrent.imageUrl = participant.imageUrl;
        userCurrent.isHandRaised = participant.isHandRaised;
        userCurrent.isCameraOff = participant.isCameraOff;
        userCurrent.isAudioOff = participant.isAudioOff;
        this.publishedParticipants.push(userCurrent);

        const index = this.usersPublished.findIndex(user => user.uid === participant.uid);
        this.usersPublished.splice(index, 1);

        return false;
      }

      if (this.oldParticipants.find(participantOld => participantOld.uid === participant.uid)) {
        this.publishedParticipants.forEach(part => {
          if (part.uid === participant.uid) {
            part.isHandRaised = participant.isHandRaised;
            part.isCameraOff = participant.isCameraOff;
            part.isAudioOff = participant.isAudioOff;
          }
        })

        return false;
      }

      if (participant.uid === this.presenter.uid) {
        return false;
      }

    });
    this.onlineParticipants = this.newParticipants;
    this.$forceUpdate();
  }

  @Watch('layouts')
  onLayouts(newVal) {
    if (newVal === "auto") {
      this.isShowResidentsRow = !this.isShowResidentsRow;
    }
    if (newVal === "spotlight") {
      this.isShowResidentsRow = false;
    }
    if (newVal === "topbar") {
      this.isShowResidentsRow = true;
    }
  }
  async created() {

    if (!this.$store.state.authModule.currentFacility) {
      await this.$store.commit("setCurrentFacilityId", this.$route.params.facilityId)
      await this.$store.dispatch("getFacility");
    }

    this.rtc = new RTCClient();
    const rtc = this.rtc;
    const eventId = this.$route.params.eventId;
    this.$store.dispatch("subscribeCalenderEvent", this.$route.params.eventId);

    rtc.on("start-stream", uid => {
      this.disableJoin = true;
      this.presenter.uid = uid;

      this.calendarEvent.id = eventId;
      this.calendarEvent.appid = this.option.appid;
      this.calendarEvent.residentsInvitees = this.residentsInvitees;
      this.calendarEvent.start = this.eventStart;
      this.calendarEvent.end = this.eventEnd;

      let isAddPresenter = true;
      this.calendarEvent?.participants.forEach(participant => {
        if (participant.userId === this.presenter.userId || participant.uid === this.presenter.uid) {
          participant.uid = this.presenter.uid;
          participant.userId = this.presenter.userId;
          participant.userName = this.presenter.userName;
          participant.imageUrl = this.presenter.imageUrl;
          isAddPresenter = false;
        }
      })
      if (isAddPresenter) {
        this.calendarEvent.participants.push(this.presenter);
      }

      this.$store.dispatch(
        "updateSingleCalenderEventVirtual",
        this.calendarEvent
      );
    });

    rtc.on("user-published", userPublished => {
      this.userPublished = userPublished;
      this.usersPublished.push(userPublished);
    });

    rtc.on("user-left", (userPublished, reason) => {
      this.publishedParticipants = this.publishedParticipants.filter(user => user.uid !== userPublished.uid);
      this.onlineParticipants = this.onlineParticipants.filter(user => user.uid !== userPublished.uid);
      this.$forceUpdate();
    });
  }
  mounted() {
    if (!this.availibleAttendance) {
      this.$store.dispatch("getAdditionalServices");
      this.$store.dispatch("getSocialClubList");
    }
  }
  beforeDestroy() {
    if (this.rtc.client) {
      this.leaveEvent()
    }
  }
  async joinEvent() {
    this.option.channel = this.calendarEvent.channelId;
    await this.rtc.joinChannel(
      this.option,
      this.calendarEvent.isBroadcast ?? false
    );
    this.disableJoin = true;
  }
  openOnlineParticipants() {
    this.isShowParticipantsOnline = !this.isShowParticipantsOnline;
  }
  leaveEvent() {
    this.disableJoin = false;
    this.publishedParticipants = [];
    this.onlineParticipants = [];
    this.isDisableVideo = true;
    this.isDisableAudio = true;
    this.isDisableScreen = false;

    this.rtc.leaveChannel();

    this.$store.dispatch("unsubscribeCalenderEvent");

    this.calendarEvent.participants = [];
    this.calendarEvent.start = this.eventStart;
    this.calendarEvent.end = this.eventEnd;

    this.$store.dispatch(
      "updateSingleCalenderEventVirtual",
      this.calendarEvent
    );
  }
  returnToCalendarEvent() {
    this.$router.push("/calendar/" + this.calendarEvent.id);
  }
  disableVideo() {
    this.isDisableVideo = !this.isDisableVideo;
    this.rtc.disableVideo(this.isDisableVideo);

    const calendarEventParticipants = this.calendarEvent.participants;
    calendarEventParticipants.forEach(participant => {
      if (participant.uid === this.presenter.uid) {
        participant.isCameraOff = !this.isDisableVideo;
      }
    });

    this.calendarEvent.participants = calendarEventParticipants;
    this.$store.dispatch(
      "updateSingleCalenderEventVirtual",
      this.calendarEvent
    );
  }
  disableAudio() {
    this.isDisableAudio = !this.isDisableAudio;
    this.rtc.disableAudio(this.isDisableAudio);

    const calendarEventParticipants = this.calendarEvent.participants;
    calendarEventParticipants.forEach(participant => {
      if (participant.uid === this.presenter.uid) {
        participant.isAudioOff = !this.isDisableAudio;
      }
    });
    this.calendarEvent.participants = calendarEventParticipants;
    this.$store.dispatch(
      "updateSingleCalenderEventVirtual",
      this.calendarEvent
    );
  }
  shareScreen() {
    this.isDisableScreen = !this.isDisableScreen;
    this.rtc.shareScreen(this.isDisableScreen, this.isDisableAudio, this.isDisableVideo);
  }
  setAudioParticipant(participantAudio) {
    const calendarEventParticipants = this.calendarEvent.participants;
    calendarEventParticipants.forEach(participant => {
      if (participant.uid === participantAudio.uid) {
        participant.isAudioOff = participantAudio.isAudio;
        participant.isHandRaised = participantAudio.isHand;
      }
    });
    this.calendarEvent.participants = calendarEventParticipants;
    this.$store.dispatch(
      "updateSingleCalenderEventVirtual",
      this.calendarEvent
    );
  }
  onChangeLayout() {
    this.isChangeLayout = !this.isChangeLayout;
  }
  closeLayout() {
    this.isChangeLayout = false;
  }
}
